module.exports = __webpack_public_path__ + "img/log3.c7e0449e.png";